export default __webpack_public_path__ + "static/ism-home-desktop1-756a2d0eb68bb8cb28b588f65cdbbe4f.png";